export default __webpack_public_path__ + "static/media/sign.cfe74fad.png";